module.exports = __webpack_public_path__ + "static/media/how_to_spot_a_phishing_email.d742c99d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/how_to_spot_a_phishing_email.jpg
// module id = 206
// module chunks = 0